import requestSlice from "shared/lib/request-monitoring/store/requestSlice"

import { combineReducers, configureStore } from "@reduxjs/toolkit"
import productPositionUpdatesSlice from "entities/product-positions/model/store/productPositionUpdatesSlice"
import productObjCacheSlice from "entities/products/model/store/productObjCacheSlice"
import projectsSlice from "entities/projects/model/store/projectsSlice"
import projectSlice from "features/project-management/model/store/projectSlice"
import scrollSlice from "features/scroll-management/model/store/scrollSlice"
import buildingReferenceSlice from "pages/building-reference-page/model/store/buildingReferenceSlice"

import healthSlice from "./health/healthSlice"

const rootReducer = combineReducers({
  table: projectSlice,
  request: requestSlice,
  projects: projectsSlice,
  health: healthSlice,
  productPositionUpdates: productPositionUpdatesSlice,
  scroll: scrollSlice,
  productObjCache: productObjCacheSlice,
  buildingReference: buildingReferenceSlice
})

export type RootState = ReturnType<typeof rootReducer>

function getStoreInternal(preloadedState?: Partial<RootState>) {
  return configureStore({ reducer: rootReducer, preloadedState })
}

export const store = getStoreInternal()

export function getStore(preloadedState?: Partial<RootState>) {
  return getStoreInternal(preloadedState)
}
